import React, { useEffect, useState, Fragement } from "react";
import axios from "axios";
import { server } from "../../../utills/utils";
import styled from "styled-components";
import { useMutation, gql } from "@apollo/client";
import Resizer from "react-image-file-resizer";

import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";
import Spinner from "../../Modals/SpinnerModal";

import Upload from "../../../assets/upload.png";

const UPLOAD_FILE = gql`
  mutation uploadToAws($file: Upload!) {
    uploadToAws(file: $file) {
      url
    }
  }
`;

const Container = styled.div`
  width: 100%;
  height: 70vh;
`;
const Header = styled.div`
  width: 100%;
  height: 10%;
  border-bottom: 1px solid #eee;
`;
const Body = styled.div`
  width: 100%;
  height: 74%;
  padding: 3% 0;
  overflow-y: scroll;
`;
const Footer = styled.div`
  width: 100%;
  height: 10%;
  border-top: 1px solid #eee;
`;
const Title = styled.h3`
  width: 80%;
  float: left;
  padding: 0;
  margin: 0;
  text-align: left;
`;
const CloseButton = styled.button`
  float: right;
`;
const ImageContainer = styled.div`
  width: 90%;
  height: 80%;
  margin-left: 5%;
  text-align: center;
`;
const Image = styled.img`
  width: 22.5%;
  height: 140px;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  border: 1px solid #ccc;
  @media (max-width: 789px) {
    width: 45%;
    height: 150px;
  }
`;
const Images = styled.div`
  width: 100%;
  height: 60px;
  padding: 10px 0;
  text-align: center;
`;
const NotActiveImage = styled.img`
  width: 50px;
  height: 50px;
  border: 2px solid gray;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 4px;
`;
const ActiveImage = styled.img`
  width: 50px;
  height: 50px;
  border: 2px solid green;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 4px;
`;
const PriceContainer = styled.div`
  width: 50%;
  height: 100%;
  float: left;
`;
const AddToCart = styled.button`
  float: right;
  padding: 10px 30px;
  margin: 10px 10px 0 0;
  font-weight: 600;
  font-size: 1em;
  background: #276fb7;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Price = styled.p`
  font-weight: 600;
  margin: 10px 0 0 0;
  padding: 0;
`;
const Quantity = styled.p`
  margin: 0;
  padding: 0;
  color: #e25f17;
`;
const ImageView = styled.div`
  width: 100%;
  height: 200px;
`;
const UploadButton = styled.div`
  width: 20%;
  margin-left: 40%;
  text-align: center;
  padding-top: 40px;
  cursor: pointer;
`;
const ImageBox = styled.div`
  width: 23%;
  height: 140px;
  background: rgb(180, 177, 177);
  @keyframes mymove {
    from {
      background-color: #e6e1e1;
    }
    to {
      background-color: #c7caca;
    }
  }
  animation: mymove 1s infinite;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  @media (max-width: 789px) {
    width: 45%;
    height: 150px;
  }
`;
const InputBox = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;
const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
`;
const Input1 = styled.input`
  width: 45%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
  float: left;
`;
const Input2 = styled.input`
  width: 45%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
  float: right;
`;
// const SubCategory = styled.select`

// `
const Description = styled.textarea`
  width: 97.5%;
  height: 200px;
  border: none;
  outline: none;
  padding: 1%;
  font-size: 1.1em;
  border: 1px solid #ccc;
  margin: 10px 0;
  resize: none;
  font: inherit;
  border-radius: 5px;
`;
function AddProductView(props) {
  let imageBoxes = [];
  const [name, setName] = useState("");
  const [price, setPrice] = useState(null);
  const [measure, setMeasure] = useState("");
  const [product, setProduct] = useState({});
  const [complete, setComplete] = useState(false);
  const [imageUpload, setUpload] = useState(false);
  const [images, setImages] = useState([]);
  const [totalImages, setTotalImages] = useState(0);
  console.log("ProductView", props);
  const [productImage, setProductImage] = useState("");
  const [subCatId, setSubCatId] = useState(null);
  const [subId, setSubId] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [spinner, setSpinner] = useState(false);

  console.log("Props", props);

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const priceChangeHandler = (e) => {
    setPrice(e.target.value);
  };
  const descriptionHandler = (e) => {
    setDescription(e.target.value);
  };
  // const categoryChangeHandler = (e) => {
  //   let index = e.target.value;
  //   setCategoryId(index);
  //   setSubcats(categories[index].subCategories);
  // };

  const SubCatChangeHandler = (e) => {
    setSubCatId(e.target.value);
  };
  const brandChangeHandler = (e) => {
    setBrandName(e.target.value);
  };
  const measureChangeHandler = (e) => {
    setMeasure(e.target.value);
  };

  const closeModal = () => {
    props.closeModal();
    // setComplete(false);
  };
  const changeImageHandler = (id) => {
    // setActiveImage(id);
  };
  const resizeFile = (file) =>
    new Promise(async (resolve) => {
      await Resizer.imageFileResizer(
        file,
        1400,
        1200,
        "WEBP",
        100,
        0,
        (uri) => {
          // resolve(uri);
          console.log("UK uri", uri);
          const file = uri;
          console.log("UK uri 1", file);
          uploadToAws({ variables: { file } });
        },
        "file"
      );
    });

  const handleFileChange = async (e) => {
    setUpload(true);
    const files = e.target.files;
    setTotalImages(e.target.files.length);
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      resizeFile(file);
      console.log("resize", file);
      //uploadToAws({ variables: { file } });
    }
  };
  for (let i = 0; i < totalImages; i++) {
    imageBoxes.push(<ImageBox />);
  }

  //Image upload
  const [uploadToAws] = useMutation(UPLOAD_FILE, {
    onCompleted: (data) => {
      setProductImage(data.uploadToAws.url);
      const newImages = images;
      newImages.push(data.uploadToAws.url);
      setImages(newImages);
      setTotalImages(totalImages - 1);
    },
  });
  const addHandler = async () => {
    console.log(name, price, images, measure, description);
    try {
      // e.preventDefault();
      // setAddProductModal(false);
      setSpinner(true);
      // console.log(
      //   name,
      //   price,
      //   categories[categoryId]._id,
      //   subCategories[subCatId]._id,
      //   measure,
      //   brandName,
      //   images
      // );
      const product = await axios.post(server, {
        query: `
              mutation{
                addShopProductOwn(
                  input:{
                    shopId:"${props.merchant._id}"
                    name:"${name}",
                    price:${price},
                    categoryId:"${props.merchant.categoryId}",
                    categoryName:"${props.merchant.categoryName}",
                    subCategoryId:"${
                      props.category.subCategories[subCatId]._id
                    }",
                    subCategoryName:"${
                      props.category.subCategories[subCatId].name
                    }",
                    measurment:"${measure}",
                    brandName:"${brandName}",
                    images:${JSON.stringify(images).replace(
                      /"([^(")"]+)":/g,
                      "$1:"
                    )},
                    description:"${description}"
                  }
                ){
                  _id
                  name
                  price
                  product{
                  _id
                  name
                  brandName
                  brandId
                  name
                  price
                  measurment
                  images
                  }
                }
              }
           `,
      });
      console.log("add product", product);

      // setProducts(product.data.data.addProduct);
      setName("");
      setPrice("");
      setImages([]);
      setUpload(false);
      setDescription("");
      setMeasure("");
      setProductImage("");
      setSpinner(false);
      props.addProductOwnHandler(product.data.data.addShopProductOwn);
    } catch (error) {
      throw error;
    }
  };
  const getGetegory = async () => {
    try {
      if (props.merchant) {
        await axios
          .post(server, {
            query: `
           query{
            getCategory(catId:"${props.merchant.categoryId}"){
              _id
              name
              subCategories{
                _id
                name
              }

            }
           }
         `,
          })
          .then((res) => {
            console.log("Category", res);
            setCategory(res.data.data.getCategory);
          });
      }
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    //fetchProduct(props.id);
    //getGetegory();
    setComplete(true);
  }, [props.merchant.categoryId]);
  let view;
  complete && product
    ? (view = (
        <Container>
          <Spinner show={spinner} />
          <Header>
            <Title>
              {props.merchant.categoryId == "6129e467f8785a2974c9915a"
                ? "Add Service"
                : "Add Product"}
            </Title>
            <CloseButton onClick={closeModal}>Close</CloseButton>
          </Header>
          <Body>
            {!imageUpload ? (
              <ImageView>
                <UploadButton>
                  <label for="file-input">
                    <img
                      style={{ width: "70px", height: "70px" }}
                      src={Upload}
                    />
                  </label>
                  <input
                    id="file-input"
                    className="custom-file-input"
                    required="true"
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    accept="image/x-png,image/gif,image/jpeg"
                  />
                </UploadButton>
                {/* <ImagePreview>
                  {uploadDone ? (
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={productImage}
                      alt="productimage"
                    />
                  ) : null}
                </ImagePreview> */}
              </ImageView>
            ) : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "20px 0",
                  flexFlow: "wrap",
                  height: "auto",
                  flexDirection: "row",
                }}
              >
                {images.map((img) => (
                  <Image src={img} />
                ))}
                {imageBoxes}
              </div>
            )}
            <Input
              value={name}
              onChange={nameChangeHandler}
              required="true"
              type="text"
              placeholder={
                props.merchant.categoryId == "6129e467f8785a2974c9915a"
                  ? "Service name"
                  : "Product name"
              }
            />
            <InputBox>
              <Input1
                value={measure}
                onChange={measureChangeHandler}
                required="true"
                type="text"
                placeholder="Measurement"
              />
              <Input2
                onChange={priceChangeHandler}
                value={price}
                required="true"
                type="number"
                min="0"
                placeholder={
                  props.merchant.categoryId == "6129e467f8785a2974c9915a"
                    ? "Service price"
                    : "Product price"
                }
              />
            </InputBox>
            {props.merchant.categoryId !== "6129e467f8785a2974c9915a" && (
              <Input
                value={brandName}
                onChange={brandChangeHandler}
                required="true"
                type="text"
                placeholder="Brand name"
              />
            )}
            <select
              className="SubCategory"
              required="true"
              onChange={SubCatChangeHandler}
            >
              <option value="">Select Subcategory</option>
              {props.category != null &&
                props.category.subCategories.map((sub, id) => {
                  return <option value={id}>{sub.name}</option>;
                })}
            </select>
            <Description
              value={description}
              onChange={descriptionHandler}
              type="text"
              name={description}
              placeholder="Description"
            />
          </Body>
          <Footer>
            {/* <PriceContainer>
              <Price>{product.price} TK</Price>
              <Quantity>{product.product.measurement}1 kg</Quantity>
            </PriceContainer>
            {localStorage.catId != "6129e467f8785a2974c9915a" ? (
              <AddToCart
                onClick={() => props.addToCartHandler(props.productId)}
              >
                Add to basket
              </AddToCart> */}
            <AddToCart onClick={addHandler}>
              {props.merchant.categoryId == "6129e467f8785a2974c9915a"
                ? "Add Service"
                : "Add Product"}
            </AddToCart>
            {/* ) : null} */}
          </Footer>
        </Container>
      ))
    : (view = <p>Loading...</p>);
  console.log("Sub cat id", subCatId);
  return view;
}

//export default ProductView;
const mapStateToProps = (state) => {
  return {
    merchant: state.utils.merchant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMerchant: (data) => {
      dispatch({
        type: actionTypes.SET_MERCHANT,
        data,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddProductView);
